<template>
  <div class="global__scrollbar position-relative" style="height: 42rem">
    <div class="row m-0 h-100">
      <div class="w-100">
        <iframe
          :src="dataMaps"
          style="
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          width: 100%;
          height: 100%;
          border: none;
          margin: 0;
          padding: 0;
          overflow: hidden;
          z-index: 999999;
        "
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
    <div
      v-if="!dataMaps.includes('mceasy')"
      class="position-absolute w-100 style-custom"
      :style="responsiveBottom"
    >
      <div class="d-flex justify-content-center position-relative mt-2 mb-4">
        <img
          class="position-fixed"
          :src="iconSvg"
          alt=""
          style="cursor: pointer;"
          @click="upDown(dataUp)"
        />
      </div>
      <div class="position-relative" :class="styleCss">
        <p
          class="ml-5 mb-4"
          style="font-size: 14px;font-weight: 700;color: #0E0E0E;"
        >
          Shipment Tracking
        </p>
        <div
          v-for="(item, i) in dataStatus"
          :key="i"
          class="d-flex align-items-baseline position-relative ml-5 mb-2"
        >
          <p class="status-name mr-4">{{ item.statusName }}</p>
          <div>
            <img :src="iconLink" class="mr-4" alt="" />
            <div
              v-if="!(i === dataStatus.length - 1)"
              style="width: 1px;
              width: 1px;
              height: 100%;
              position: absolute;
              top: 20px;
              left: 141px;
              background: rgb(216, 216, 216);"
            ></div>
          </div>
          <div class="status-detail ml-4" v-html="item.statusDetail"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MapTrackingLink',
  props: {
    dataMaps: String,
    dataStatus: [String, Array]
  },
  data() {
    return {
      iconSvg: require('@/assets/image/icon/iconUp.svg'),
      iconLink: require('@/assets/image/icon/iconLink.svg'),
      iconLink2: require('@/assets/image/icon/tracking-dots.svg'),
      styleCss: 'scroll-down',
      dataUp: 'up',
      responsiveBottom: 'bottom: 1%',
      innerHeight: window.innerHeight
    };
  },
  mounted() {
    console.log(window.innerHeight);
    if (window.innerHeight > 922) {
      this.responsiveBottom = 'bottom: 1%';
    } else if (window.innerHeight > 802) {
      this.responsiveBottom = 'bottom: 15%';
    } else if (window.innerHeight > 732) {
      this.responsiveBottom = 'bottom: 28%';
    } else {
      this.responsiveBottom = 'bottom: 50%';
    }
  },
  methods: {
    upDown(data) {
      if (data === 'up') {
        this.dataUp = 'down';
        this.iconSvg = require('@/assets/image/icon/iconDown.svg');
        this.styleCss = 'scroll-up';
      } else {
        this.dataUp = 'up';
        this.iconSvg = require('@/assets/image/icon/iconUp.svg');
        this.styleCss = 'scroll-down';
      }
    }
  }
};
</script>

<style>
.scroll-up {
  height: 400px;
  overflow-y: scroll;
  animation: up 0.5s forwards;
}
.scroll-down {
  height: 200px;
  overflow-y: scroll;
  animation: down 0.5s forwards;
}
.style-custom {
  background-color: #fff;
  z-index: 100;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  padding-bottom: 2rem;
}
.status-name {
  font-size: 12px;
  font-weight: 700;
  color: #0e0e0e;
  width: 110px;
  word-break: break-all;
}
.status-detail {
  width: 50%;
  font-size: 12px;
  word-break: break-all;
}
::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
@keyframes up {
  from {
    height: 200px;
  }
  to {
    height: 400px;
  }
}
@keyframes down {
  from {
    height: 400px;
  }
  to {
    height: 200px;
  }
}
@media screen and (min-width: 807px) {
  .style-custom {
    bottom: 5%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/managementShipment/detail/MapTrackingLink.vue